import { atom } from 'recoil';

export const drawerUpdatedState = atom({
    key: 'drawerUpdatedState',
    default: false,
});
